import { render, staticRenderFns } from "./PaySetting.vue?vue&type=template&id=147fad10&"
import script from "./PaySetting.vue?vue&type=script&lang=js&"
export * from "./PaySetting.vue?vue&type=script&lang=js&"
import style0 from "./PaySetting.vue?vue&type=style&index=0&id=147fad10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports